import { render, staticRenderFns } from "./BattlePrelims.vue?vue&type=template&id=394a8940&scoped=true"
import script from "./BattlePrelims.vue?vue&type=script&lang=js"
export * from "./BattlePrelims.vue?vue&type=script&lang=js"
import style0 from "./BattlePrelims.vue?vue&type=style&index=0&id=394a8940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a8940",
  null
  
)

export default component.exports